import { render, staticRenderFns } from "./AdminProductBaseSettings.vue?vue&type=template&id=70fae36e&scoped=true"
import script from "./AdminProductBaseSettings.vue?vue&type=script&lang=js"
export * from "./AdminProductBaseSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminProductBaseSettings.vue?vue&type=style&index=0&id=70fae36e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fae36e",
  null
  
)

export default component.exports